/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-props-no-spreading */

import _ from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useUser } from 'react-omnitech-api'
import { Helmet } from 'react-helmet'
import useStyles from '../content-group/templates/content-group-style'
import Title from '../title-detail'
import ProductCard from '../product-card'
import Button from '../button'
import {
  useCustomerRankSettings,
} from '../../hook'

import ArrowFat from '../../assets/icons/icon_solid_arrow.svg'
import { combineClassNames } from '../../helpers'

function ProductGroupView(props) {
  const {
    className,
    currency,
    productGroupCode,
    productGroupLines,
    title,
    siblings,
    siblingsLoading,
    onClick,
    onClickTrackEvent,
  } = props
  const { t } = useTranslation()
  const { default: defaultRank } = useCustomerRankSettings()
  const {
    loyaltyInformation,
  } = useUser()
  const currentRank = _.get(loyaltyInformation, 'currentCustomerRank.code', defaultRank)
  const styles = useStyles()

  if (productGroupLines.length === 0) return <div className={styles.placeholderDiv} />

  const getProductProps = (item, index) => {
    const siblingsProductCodes = _.get(item, 'sku.product.meta.siblingsProductCodes', [])
    const thisSiblings = _.filter(siblings, (sibling) => (
      _.includes(siblingsProductCodes, _.get(sibling, 'product.code', '////'))
    ))
    const haveSiblings = !_.isEmpty(thisSiblings)
    const priceSuffix = haveSiblings && t('screens.product.price.up')
    const lowestSellPriceSibling = _.reduce(thisSiblings, (result, sibling) => {
      if (
        _.toNumber(_.get(result, 'sellPrice', 0))
        > _.toNumber(_.get(sibling, 'sellPrice', 0))
      ) {
        result = sibling
      }
      return result
    }, _.first(thisSiblings))
    const displaySellPrice = haveSiblings
      ? _.get(lowestSellPriceSibling, 'sellPrice')
      : _.get(item, 'sku.colorOption.sellPrice')
    const displayOriginalPrice = haveSiblings
      ? _.get(lowestSellPriceSibling, 'originalPrice')
      : _.get(item, 'sku.colorOption.originalPrice')
    const displayMemberPrice = haveSiblings
      ? _.get(lowestSellPriceSibling, `meta.memberPrice.${currentRank}`)
      : _.get(item, `sku.meta.memberPrice.${currentRank}`)
    const itemProps = {
      productId: _.get(item, 'sku.product.id'),
      colorOptionVariantType: _.get(item, 'sku.product.colorOptionVariantType', {}),
      imageUrl: _.get(item, 'sku.colorOption.defaultImage.versions.webLarge'),
      title: _.get(item, 'sku.product.title'),
      colorName: _.get(item, 'sku.colorOption.name'),
      colorOptionId: _.get(item, 'sku.colorOption.id'),
      sellPrice: displaySellPrice,
      originalPrice: displayOriginalPrice,
      memberPrice: displayMemberPrice,
      priceSuffix,
      priceLoading: siblingsLoading,
      activeCustomLabels: _.get(item, 'sku.colorOption.activeCustomLabels'),
      favourite: _.get(item, 'sku.colorOption.favourite'),
      url: _.get(item, 'sku.product.canonicalHref'),
      sku: _.get(item, 'sku'),
      stockLevel: _.get(item, 'sku.colorOption.stockLevel'),
      index: index + 1,
      list: title,
      onClickTrackEvent,
    }
    return itemProps
  }

  const urlNavigation = _.isNumber(productGroupCode)
    ? `/products/?productGroupId=${productGroupCode}`
    : `/products/?productGroupCodeEq=${productGroupCode}`

  return (
    <div className={combineClassNames([styles.productGroupStyle, className])}>
      {/* TODO: Need to check why price and stock level is not loaded correctly
      in the html output */}
      {/* <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'http://schema.org',
            '@type': 'ItemList',
            name: title,
            itemListElement: _.map(productGroupLines, (item, index) => {
              const itemProps = getProductProps(item, index)
              return ({
                '@type': 'Product',
                name: item.title,
                // description: pi.description,
                image: item.imageUrl,
                url: item.url,
                offers: {
                  '@type': 'Offer',
                  availability: _.isNull(item.stockLevel) || item.stockLevel > 0
                    ? 'https://schema.org/InStock'
                    : 'https://schema.org/SoldOut',
                  price: item.sellPrice,
                  priceCurrency: _.get(currency, 'code'),
                },
              })
            }),
          })}
        </script>
      </Helmet> */}
      <Title
        text={title}
        uppercase
        margin="3rem 0 1rem"
      />
      <div className={styles.row}>
        {
          productGroupLines.map((item, index) => {
            const itemProps = getProductProps(item, index)
            return (
              <div key={`product-group-${_.get(item, 'sku.id', '')}`} className={styles.productCardItem}>
                <ProductCard item={item} key={`product-group-line-${_.get(item, 'sku.id', '')}`} {...itemProps} />
              </div>
            )
          })
        }
      </div>
      <div className={styles.buttonMoreStyle}>
        <Button
          inline
          text={t('screens.home.ui.productsGroup.more')}
          navigate={urlNavigation}
          iconImage={ArrowFat}
          onClick={onClick}
          className={styles.moreButton}
          iconClassName={styles.moreButtonIcon}
        />
      </div>
    </div>
  )
}

export default ProductGroupView
